import * as React from "react";

const TooltipDecorator = (props: any) => (
    <svg width={64} height={64} viewBox="0 0 64 64" {...props}>
        <g id="Surface" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Utility" transform="translate(-289.000000, -311.000000)">
                <g id="01-Input-Field-Copy-8" transform="translate(289.000000, 296.000000)">
                    <g id="tmb_surface_input" transform="translate(8.000000, 26.000000)">
                        <polygon id="rect" fill="#7B838C" points="0 0 48 0 48 20 28 20 24 24 20 20 0 20"/>
                        <path d="M8,6.5 L39,6.5" id="label-copy" stroke="#E8E9EB" strokeWidth="2" strokeLinecap="round"/>
                        <path d="M8,12.5 L28,12.5" id="label-copy-12" stroke="#E8E9EB" strokeWidth="2" strokeLinecap="round"/>
                        <path d="M2,28 L2,40 L46,40 L46,28 L2,28 Z" id="rect" stroke="#D2D5D8" strokeWidth="4" fill="#D2D5D8"/>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export default TooltipDecorator;

